import { Account } from 'src/interfaces/banking';

export const getTotalBalance = (accounts: Account[]) => accounts.reduce((prev, curr) => prev + Number(curr.valuation.amount), 0).toString();
